import http from "api/https";

export interface Organization {
  id?: number;
  organization_code: string;
  name: string;
  short_name?: string;
  organization_type?: string;
  inn?: string;
  address?: string;
  phone?: string;
  email?: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
  created_by?: number;
  updated_by?: number;
}

// Получение списка всех организаций
export const getOrganizations = (): Promise<any> => {
  return http.get("/organization/GetAll");
};

// Получение одной организации по ID
export const getOrganization = (id: number): Promise<any> => {
  return http.get(`/organization/GetOneById?id=${id}`);
};

// Создание новой организации
export const createOrganization = (data: Organization): Promise<any> => {
  return http.post(`/organization/Create`, data);
};

// Обновление существующей организации
export const updateOrganization = (data: Organization): Promise<any> => {
  return http.put(`/organization/Update`, data);
};

// Удаление организации
export const deleteOrganization = (id: number): Promise<any> => {
  return http.remove(`/organization/Delete?id=${id}`, {});
};